import _extends from 'babel-runtime/helpers/extends';
import _Object$keys from 'babel-runtime/core-js/object/keys';

import { filedGetFieldAPI } from '@/api/crm/common';
import { crmBusinessSaveAPI } from '@/api/crm/business';

import XrCreate from '@/components/XrCreate';
import CreateSections from '@/components/CreateSections';
import WkFormItems from '@/components/NewCom/WkForm/WkFormItems';

import { XhBusinessStatus, XhProduct, CrmRelativeCell } from '@/components/CreateCom';

import CustomFieldsMixin from '@/mixins/CustomFields';
import { isEmpty } from '@/utils/types';

export default {
  // 新建编辑
  name: 'BusinessCreate',

  components: {
    XrCreate: XrCreate,
    CreateSections: CreateSections,
    CrmRelativeCell: CrmRelativeCell,
    XhBusinessStatus: XhBusinessStatus,
    XhProduct: XhProduct,
    WkFormItems: WkFormItems
  },

  mixins: [CustomFieldsMixin],

  props: {
    action: {
      type: Object,
      default: function _default() {
        return {
          type: 'save',
          id: '',
          data: {}
        };
      }
    }
  },

  data: function data() {
    return {
      loading: false,
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {}
    };
  },


  computed: {
    title: function title() {
      return this.action.type === 'update' ? '编辑商机' : '新建商机';
    }
  },

  watch: {},

  created: function created() {
    this.getField();
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    /**
     * 获取数据
     */
    getField: function getField() {
      var _this = this;

      this.loading = true;
      var params = {
        // label: crmTypeModel.business
        types: 'crm_business',
        module: 'crm',
        controller: 'business',
        action: this.action.type,
        format: 2
      };

      if (this.action.type == 'update') {
        params.action_id = this.action.id;
      }

      filedGetFieldAPI(params).then(function (res) {
        var list = res.data || [];
        var assistIds = _this.getFormAssistIds(list);

        var baseFields = [];
        var fieldList = [];
        var fieldRules = {};
        var fieldForm = {};
        list.forEach(function (children) {
          var fields = [];
          children.forEach(function (item) {
            var temp = _this.getFormItemDefaultProperty(item);
            temp.show = !assistIds.includes(item.formAssistId);

            var canEdit = _this.getItemIsCanEdit(item, _this.action.type);
            // 是否能编辑权限
            if (temp.show && canEdit) {
              fieldRules[temp.field] = _this.getRules(item);
            }

            // 是否可编辑
            temp.disabled = !canEdit;

            // 禁止某些业务组件选择
            if (temp.form_type == 'customer') {
              if (_this.action.type == 'relative') {
                var relativeDisInfos = {
                  customer: { customer: true },
                  contacts: { customer: true }

                  // 在哪个类型下添加
                };var relativeTypeDisInfos = relativeDisInfos[_this.action.crmType];
                if (relativeTypeDisInfos) {
                  // 包含的字段值
                  temp.disabled = relativeTypeDisInfos[item.form_type] || false;
                }
              }
            }

            // 特殊字段允许多选
            _this.getItemRadio(item, temp);

            if (item.form_type === 'business_status') {
              temp.disabled = _this.action.type === 'update';
            }

            // 获取默认值
            if (temp.show) {
              fieldForm[temp.field] = _this.getItemValue(item, _this.action.data, _this.action.type);
            }
            fields.push(temp);
            baseFields.push(item);
          });
          fieldList.push(fields);
        });

        _this.baseFields = baseFields;
        _this.fieldList = fieldList;
        _this.fieldForm = fieldForm;
        _this.fieldRules = fieldRules;

        _this.loading = false;
      }).catch(function (e) {
        console.log(e);
        _this.loading = false;
      });
    },


    /**
     * 保存
     */
    saveClick: function saveClick() {
      var _this2 = this;

      this.loading = true;
      var crmForm = this.$refs.crmForm;

      crmForm.validate(function (valid) {
        if (valid) {
          var params = _this2.getSubmiteParams(_this2.baseFields, _this2.fieldForm);
          // this.submiteParams(params)
          if (_this2.action.type === 'update') {
            params.id = _this2.action.id;
          }
          _this2.submiteParams(params);
        } else {
          _this2.loading = false;
          // 提示第一个error
          _this2.getFormErrorMessage(crmForm);
          return false;
        }
      });
    },


    /**
     * 提交上传
     */
    submiteParams: function submiteParams(params) {
      var _this3 = this;

      if (this.action.type == 'update') {
        params.id = this.action.id;
        params.batchId = this.action.batchId;
      }

      // 相关添加时候的多余提交信息
      if (this.action.relativeData && _Object$keys(this.action.relativeData).length) {
        params = _extends({}, params, this.action.relativeData);
      }

      crmBusinessSaveAPI(params).then(function (res) {
        _this3.loading = false;

        _this3.$message.success(_this3.action.type == 'update' ? '编辑成功' : '添加成功');

        _this3.close();

        // 保存成功
        _this3.$emit('save-success', {
          type: 'business'
        });
      }).catch(function () {
        _this3.loading = false;
      });
    },


    /**
     * 验证唯一
     */
    UniquePromise: function UniquePromise(_ref) {
      var field = _ref.field,
          value = _ref.value;

      return this.getUniquePromise(field, value, this.action);
    },


    /**
     * change
     */
    formChange: function formChange(field, index, value, valueList) {
      if (['select', 'checkbox'].includes(field.form_type) && field.remark === 'options_type' && field.optionsData) {
        var _getFormContentByOpti = this.getFormContentByOptionsChange(this.fieldList, this.fieldForm),
            fieldForm = _getFormContentByOpti.fieldForm,
            fieldRules = _getFormContentByOpti.fieldRules;

        this.fieldForm = fieldForm;
        this.fieldRules = fieldRules;
      }
    },


    /**
     * 地址change
     */
    otherChange: function otherChange(data, field) {
      console.log(data, field);
      if (field.form_type === 'business_type') {
        var statusItem = this.getItemWithFromType(this.fieldList, 'business_status');
        if (statusItem) {
          if (isEmpty(data.value)) {
            this.fieldForm[field.field] = '';
          } else {
            if (data.type != 'init') {
              // 编辑初始化时 不重置
              this.fieldForm[field.field] = '';
            }

            var typeObj = data.data.find(function (item) {
              return item.type_id == data.value;
            });
            statusItem.setting = typeObj.statusList || [];
            this.$set(this.fieldForm, statusItem.field, statusItem.setting.length > 0 ? statusItem.setting[0].status_id : '');
          }
        }
      } else if (field.form_type === 'product') {
        this.fieldForm.money = data.value.total_price || '';
      }
      this.$set(this.fieldForm, field.field, data.value);
      this.$refs.crmForm.validateField(field.field);
    },


    /**
     * 关闭
     */
    close: function close() {
      this.$emit('close');
    }
  }
};